import PageCommon from "./PageCommon.js";

import Appear from "./classes/Appear.js";

export default class PageSearch extends PageCommon {
	constructor() {
		super();
	}
	init(data) {
		super.init(null);
		this.showPreloader(false);

		// dispaccio un evento globale
		this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);

		this.bindEvents();
		this.setPlugins();
		this.colorlink();
		this.setupMenu();

		this.appear = new Appear();
		this.appear.init();

		$(".moreBox").slice(0, 5).show();
		if ($(".blogBox:hidden").length > 5) {
			$("#loadMore").show();
		} else {
			$("#loadMore").fadeOut("slow");
		}
		$("#loadMore").on("click", (event) => {
			event.preventDefault();
			$(".moreBox:hidden").slice(0, 5).slideDown();
			if ($(".moreBox:hidden").length == 0) {
				$("#loadMore").fadeOut("slow");
			}
		});
	}
}
